<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { ref } from "vue";

const isActive = ref(false);
const toggle = () => {
    isActive.value = !isActive.value;
};
</script>

<template>
    <slot v-bind="{ isActive, toggle }" />
</template>
